import APIClient from '@/shared/http/clients/api'

const resourceName = 'despesa'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}`, data, config)
const EditaDespesa = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/EditaDespesa`, data, config)
const GetByDespesaId = (despesaId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetByDespesaId/${despesaId}`, data, config)
const DespesaById = (despesaId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/DespesaById/${despesaId}`, data, config)
const GetSituacaoDespesaId = (despesaId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetSituacaoDespesaId/${despesaId}`, data, config)
const GetAllDiscount = (data = {}, limit, index, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllDiscount?limit=${limit}&index=${index}`, data, config)
const GetAllReembolso = (data = {}, limit, index, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllReembolso?limit=${limit}&index=${index}`, data, config)
const GetAllReembolsoDiretoria = (empresaid, data = {}, limit, index, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllReembolsoDiretoria/${empresaid}/?limit=${limit}&index=${index}`, data, config)
const CalcularTotalDescont = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/CalcularTotalDescont`, data, config)
const calculartotalReembolso = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/calculartotalReembolso`, data, config)
const GetAllPaging = (companyID, type, limit, index, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}/tipo/${type}/list?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const SetApprovedlstids = (data, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ActivedByDiretoria`, data, config)
const ActivedByDiretoriaDesc = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ActivedByDiretoriaDesc`, data, config)
const DesaActivedByDiretoriaDesc = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/DesaActivedByDiretoriaDesc`, data, config)
const ActivedByDiretoriaReembolso = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ActivedByDiretoriaReembolso`, data, config)
const DesaActivedByDiretoria = (data, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/DesaActivedByDiretoria`, data, config)
const SetApproved = (id, situation, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/aprovado/${id}/${situation}`, config)
const SetDisapproved = (id, situation, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/reprovado/${id}/${situation}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const Search = (data = {}, limit, index, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/search?limit=${limit}&index=${index}`, data, config)
const Print = (data = [], config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/print`, data, config)
const ImportDes = (modelo, reembolso, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/importDes/${modelo}/${reembolso}`, data, config)
const ExportExcel = (data = [], config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/export`, data, config)
const GetEnumSituacao = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetEnumSituacao`, data, config)
const Actived = (data = [], config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/lstActived`, data, config)
// companyId vai SEMPRE, mesmo vazio. Omitir o parametro fazia o backend listar todas as empresas
// (CRUDDespesa.GetAllDespesas, filtro condicional) — vazamento entre empresas na aba Prestacao de
// contas do Reembolso de Viagem. Vazio agora significa "sem recorte" e a lista volta vazia.
const GetAllDespesas = (data = {}, limit, index, companyId, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllDespesas?limit=${limit}&index=${index}&companyId=${companyId || ''}`, data, config)
const NextStatusDespesaAproved = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/NextStatusDespesaAproved/${id}`, data, config)
const NextStatusNoneLote = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/NextStatusNoneLote/${id}`, data, config)
const GeteSituacaoAcesso = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GeteSituacaoAcesso`, data, config)
const NextStatusDisaprove = (despesaId, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/NextStatusDisaprove/${despesaId}`, data, config)
const GetAllHistory = (favorecidoID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllHistory/${favorecidoID}`, data, config)
const ImportExcelByIds = (data = [], config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ImportExcelByIds`, data, config)
const GetLogById = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetLogById/${id}`, data, config)
const AlteraSituacaoDespesaParaElaboracao = (despesaid, data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/AlteraSituacaoDespesaParaElaboracao/${despesaid}`, data, config)
const AlteraSituacaDespesa = (despesaid, acao, data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/AlteraSituacaDespesa/${despesaid}/${acao}`, data, config)
const ReprovaDespesaCoordenadorRegistros = (despesaid, acao, data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/ReprovaDespesaCoordenadorRegistros/${despesaid}`, data, config)
const ExpenseRepository = {
  GetAll,
  ReprovaDespesaCoordenadorRegistros,
  EditaDespesa,
  DespesaById,
  GetSituacaoDespesaId,
  GetByDespesaId,
  GetAllReembolsoDiretoria,
  GetAllPaging,
  GetById,
  SetApproved,
  SetDisapproved,
  CalcularTotalDescont,
  Create,
  ImportDes,
  Update,
  Delete,
  Search,
  Print,
  calculartotalReembolso,
  ExportExcel,
  GetAllDiscount,
  GetAllReembolso,
  DesaActivedByDiretoria,
  SetApprovedlstids,
  GetEnumSituacao,
  ActivedByDiretoriaDesc,
  ActivedByDiretoriaReembolso,
  Actived,
  GetAllDespesas,
  NextStatusDespesaAproved,
  GeteSituacaoAcesso,
  NextStatusDisaprove,
  GetAllHistory,
  NextStatusNoneLote,
  ImportExcelByIds,
  AlteraSituacaDespesa,
  AlteraSituacaoDespesaParaElaboracao,
  GetLogById,
  DesaActivedByDiretoriaDesc
}

export default ExpenseRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/expense.js